// extracted by mini-css-extract-plugin
module.exports = {"confirmEmail":"confirmEmail__BcldX"};